import { Component, Input, OnInit } from '@angular/core';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { FilesService } from '../../../core/services/files.service';
import { NotesAndAttachmentsService } from '../../../core/services/notes-and-attachments.service';
import { FleetService } from '../../../core/services/fleet.service';
import { NzMessageService } from 'ng-zorro-antd/message';

const NOTES_AND_ATTACHMENT_UPLOAD = 'NOTES_AND_ATTACHMENT_UPLOAD';

@Component({
  selector: 'app-notes-attachments',
  templateUrl: './notes-attachments.component.html',
  styleUrls: ['./notes-attachments.component.scss'],
})
export class NotesAttachmentsComponent implements OnInit {
  @Input() fleetData: any | undefined;

  inputValue = '';
  tempInputVal = '';
  files: any[] = [];
  isVisible = false;
  status = 'create';
  data: any;
  // uploadPointer = false;
  remarks: any[] = [];
  loading = false;
  uploading = false;

  constructor(
    private filesService: FilesService,
    private notesService: NotesAndAttachmentsService,
    private fleetService: FleetService,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.notesService
      .getNotesAndAttachmentByFleet(this.fleetData?._id)
      .subscribe(
        (res) => {
          if (res === null) {
            this.status = 'create';
          } else if (res) {
            this.data = res;
            this.status = 'update';
            this.inputValue = res.note;
            this.tempInputVal = res.note;
            this.files = res.attachments;
          }
          this.loading = false;
        },
        (error) => {
          console.error('Error fetching notes and attachments:', error);
          this.loading = false;
        },
      );
    this.fleetService.getFleetRemarksByFleet(this.fleetData?._id);
    this.fleetService.fleetRemarks.subscribe((res: any) => {
      this.remarks = res;
    });

    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      this.uploading = res.loading;
    });
  }

  upload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, NOTES_AND_ATTACHMENT_UPLOAD)
      .subscribe((res) => {
        this.filesService.fileUploadingSubject.next({
          type: NOTES_AND_ATTACHMENT_UPLOAD,
          loading: false,
        });
        // this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        console.log(data);
        if (data) {
          this.files.push({ name: item.file.name, url: data.url });
          // this.uploadPointer = true;
          this.postData('upload');
        }
      });

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.inputValue = this.tempInputVal;
    this.postData('notes');
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  postData(type: string) {
    this.loading = true;
    if (this.status === 'create') {
      this.notesService
        .createNoteAndAttachment({
          fleet: this.fleetData._id,
          note: this.inputValue,
          attachments: this.files,
        })
        .subscribe(() => {
          if (type === 'notes') {
            this.message.create('success', `Notes has been created!`);
          } else {
            this.message.create('success', `Attachment has been added!`);
          }
          this.status = 'update';
          this.ngOnInit();
        });
      this.loading = false;
    } else if (this.status === 'update') {
      this.notesService
        .updateNoteAndAttachment({
          _id: this.data._id,
          note: this.inputValue,
          attachments: this.files,
          updateType: type,
        })
        .subscribe(() => {
          if (type === 'notes') {
            this.message.create('success', `Notes has been updated!`);
          } else {
            this.message.create('success', `New attachment has been added!`);
          }
        });
      this.loading = false;
    }
  }

  confirmRemoveAttachment(attachmentId: any): void {
    this.files.splice(attachmentId, 1);
    this.loading = true;
    this.notesService
      .updateNoteAndAttachment({
        _id: this.data._id,
        attachments: this.files,
        updateType: 'delete',
      })
      .subscribe(() => {
        this.message.create('success', `Attachment has been deleted!`);
      });
    this.loading = false;
  }
}
